import createIcon from '@/lib/create-icon'

const QuestionBalloonIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M7 3C4.79086 3 3 4.79086 3 7V14C3 16.2091 4.79086 18 7 18H9.75L12 21L14.25 18H17C19.2091 18 21 16.2091 21 14V7C21 4.79086 19.2091 3 17 3H7Z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinejoin='round'
    />
    <path
      d='M10 8.5V8.5C10 7.39543 10.8954 6.5 12 6.5H12.3333C13.2538 6.5 14 7.24619 14 8.16667V8.16667C14 8.69126 13.753 9.18524 13.3333 9.5L12.8 9.9C12.2964 10.2777 12 10.8705 12 11.5V11.5'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.5 14C12.5 14.2761 12.2761 14.5 12 14.5C11.7239 14.5 11.5 14.2761 11.5 14C11.5 13.7239 11.7239 13.5 12 13.5C12.2761 13.5 12.5 13.7239 12.5 14Z'
      stroke='currentColor'
    />
  </svg>,
  'QuestionBalloonIcon'
)

export default QuestionBalloonIcon
